import Http from 'common/services/Http';
import CustomFile from 'common/models/CustomFile';

export interface BudgetLineAttachmentDto {
    id: string;
    attachmentId: string;
    fileName: string;
    mimeType: string;
    size: number;
    url: string;
}

class BudgetLineAttachmentsService {
    public getAttachments (budgetLineId: string): Promise<BudgetLineAttachmentDto[]> {
        return Http.get<BudgetLineAttachmentDto[]>('budgetLineAttachments/' + budgetLineId);
    }

    public getPendingAttachments (tempKey: string): Promise<BudgetLineAttachmentDto[]> {
        return Http.get<BudgetLineAttachmentDto[]>('budgetLineAttachments/pending/' + tempKey);
    }

    public uploadPending (tempKey: string, files: CustomFile[]): Promise<BudgetLineAttachmentDto[]> {
        return Http.postWithFile<BudgetLineAttachmentDto[]>('budgetLineAttachments/upload/' + tempKey, {}, files);
    }

    public download (attachmentId: string, fileName: string): Promise<void> {
        return Http.getWithConfig<Blob>('budgetLineAttachments/download/' + attachmentId, null, { responseType: 'blob' })
            .then((blob: Blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.className = 'BODY_CLICK_IGNORE';
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            });
    }

    public upload (budgetLineId: string, files: CustomFile[]): Promise<string[]> {
        return Http.postWithFile<string[]>('budgetLineAttachments/' + budgetLineId, {}, files);
    }

    public remove (budgetLineId: string, attachmentId: string) {
        return Http.delete('budgetLineAttachments/' + budgetLineId + '/' + attachmentId);
    }
}

export default new BudgetLineAttachmentsService();
